//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";

import { mapActions } from "vuex";
import router from "../../router";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
        sortBy: "id",
        descending: true,
      },
      countings: [],
      countingName: "",
      countingId: 0,
      prompt: false,

      filter: "",

      dense: true,

      columns: [
        {
          name: "id",
          align: "left",
          label: "Id",
          field: "id",
          sortable: true,
        },
        {
          name: "name",
          align: "left",
          label: "Navn",
          field: "name",
          style: "width: 600px",
          sortable: true,
        },
        {
          name: "created",
          align: "left",
          label: "Opprettet",
          field: "created",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "createdByName",
          align: "left",
          label: "Opprettet av",
          field: "createdByName",

          sortable: true,
        },

        {
          name: "completed",
          align: "left",
          label: "Fullført",
          field: "completed",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },

        {
          name: "completedByName",
          align: "left",
          label: "Fullført av",
          field: "completedByName",

          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    await this.refresh();
  },

  methods: {
    async refresh() {
      this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });
      const res = await this.getCountings();
      this.countings = res.filter((count) => count.canceled === null);

      console.log(this.countings);

      setTimeout(() => {}, 500);
    },

    onRowClick(countingId) {
      router.push({ name: "StockCounting", params: { id: countingId } });
    },

    async newStocking() {
      // this.resetForm();
      //  this.showCounting = true;
      console.log("newStocking()");
      var object = {};
      if (this.countingName) {
        object["name"] = this.countingName;
      } else {
        object["name"] = "Ny telling";
      }

      var result = await this.postCounting(object);
      console.log(result);
      router.push({ name: "StockCounting", params: { id: result.id } });
    },

    ...mapActions("main", [
      "getCountings",
      "getCounting",
      "getCountingStocks",
      "getCountingStock",
      "getArticles",
      "postCounting",
    ]),
  },
};
